
<div class="content-left-top-cornor">
  <p-table [value]="machinesList" [loading]="loading" (sortFunction)="customSort($event)" [customSort]="true">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="machineName" class="machine" scope="col">Machine Name<p-sortIcon field="machineName"></p-sortIcon></th>
          <th pSortableColumn="machineType" class="machine" scope="col">Machine Type<p-sortIcon field="machineType"></p-sortIcon></th>
          <th pSortableColumn="processStep" class="machine" scope="col">Process Step<p-sortIcon field="processStep"></p-sortIcon></th>
          <th pSortableColumn="remainingPercent" class="machine" scope="col">Rem(Graphic)<p-sortIcon field="remainingPercent"></p-sortIcon></th>
          <th pSortableColumn="remMin" class="machine" scope="col">Rem(Min)<p-sortIcon field="remMin"></p-sortIcon></th>
          <th pSortableColumn="endTime" class="machine" scope="col">End Time<p-sortIcon field="endTime"></p-sortIcon></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-MachineStatus>
        <tr>
          <td [ngClass]="{ 'actionCompleted' : getActionStatus(MachineStatus) == 1}">
            {{MachineStatus?.machineName}}
          </td>
          <td>{{MachineStatus?.machineType}}</td>
          <td>{{MachineStatus?.processStep}}</td>
          <td class="machineStatusCol" *ngIf="isIndeterminate(MachineStatus) == 'determinate'">
            <p-progressBar  styleClass="border border-info"
              [value]="getValue(MachineStatus)"></p-progressBar>
          </td>
          <td class="machineStatusCol" *ngIf="isIndeterminate(MachineStatus) == 'indeterminate'">
            <p-progressBar mode="indeterminate"
              styleClass="border border-info"></p-progressBar>
          </td>
          <td>{{MachineStatus?.remMin}}</td>
          <td>{{MachineStatus?.endTime|date:'dd/MM/yyyy hh:mm a'}}</td>
        </tr>
      </ng-template>
  </p-table>
</div>